import { Container } from 'inversify-props';
import setupInvestorGoalScheduledDistributionWealthFlexible from './flexible/setup';
import setupInvestorGoalScheduledDistributionWealthWithdrawal from './withdrawal/setup';

// eslint-disable-next-line max-len
export default function setupInvestorGoalScheduledDistributionSowosWealth(container: Container) {
  setupInvestorGoalScheduledDistributionWealthFlexible(container);
  setupInvestorGoalScheduledDistributionWealthWithdrawal(container);
}
